export default "__VITE_ASSET__DLOqV$jp__"